import {
  CondensedHeader,
  CondensedLarge,
  Flashy,
  Icon,
  Layout,
  LayoutItem,
} from '@axiom/ui';
import type { TopTask } from '@axiom/validation';
import React from 'react';

import { TopTasksUtil } from '../../utils/top-tasks-util';

export type WorkspaceTopTaskTileProps = {
  name?: string;
  task: TopTask;
};

export const WorkspaceTopTaskTile = ({
  name,
  task,
}: WorkspaceTopTaskTileProps) => {
  const tileInfo = TopTasksUtil.getTopTaskCopy(task);

  return (
    <Layout name={name}>
      <LayoutItem rightGutter="8px" position="center" verticalGutter="16px">
        <Flashy
          name="TOP_TASK_BADGE"
          color={TopTasksUtil.getTopTaskBadgeColor(
            task.taskExpectedCompletionDateTime
          )}
        >
          <Icon name="alert-filled" />
        </Flashy>
      </LayoutItem>
      <LayoutItem topGutter="4px">
        <CondensedHeader name="TOP_TASK_HEADER" maxLines={2}>
          {tileInfo.header}
        </CondensedHeader>
        <CondensedLarge name="TOP_TASK_DESCRIPTION" maxLines={1}>
          {tileInfo.description}
        </CondensedLarge>
      </LayoutItem>
    </Layout>
  );
};
